
import {Rings} from "react-loader-spinner";
const LoaderComp = () => {
 
    return (
        <Rings
            color="rgb(155, 236, 34)"
            height={100}
            width={100}
            timeout={5000}
        />
 
    );
}
export default LoaderComp;